export default __webpack_public_path__ + "static/media/user-exclamation.a736ff56.svg";